var PROGRESS_ICON_DEFAULT = 'https://cdn.shopify.com/s/files/1/0898/6355/3363/files/Delivery.svg?v=1787042301';
var PROGRESS_ICON_SHIPPING_KEYWORD = 'versand';

var TRUSTPILOT_LOCALE = 'de-DE';
var TRUSTPILOT_TEMPLATE_ID = '5419b6ffb0d04a076446a9af';
var TRUSTPILOT_BUSINESSUNIT_ID = '61c23759a03161ac1677e4aa';

var DISCOUNT_ACCORDION_LABEL = 'Rabattcode hinzufügen';

var EXPRESS_CHECKOUT_LABEL = 'Oder Express bezahlen';

var MILESTONE_PRICE_RE = /^(.*?)(\s*€\s*[\d.,]+)\s*$/;

function isCornerReady() {
  return typeof corner !== 'undefined' && corner && typeof corner.on === 'function';
}

// The widget boots from an app embed and exposes no ready event, so wait on the
// two things it actually does: assign the global, and render its own DOM.
function whenCornerReady(callback) {
  if (isCornerReady()) {
    callback();
    return;
  }

  let done = false;
  let cornerValue = window.corner;
  let trapped = false;

  const readyObserver = new MutationObserver(function () {
    finish();
  });

  function finish() {
    if (done || !isCornerReady()) return;
    done = true;
    readyObserver.disconnect();

    if (trapped) {
      Object.defineProperty(window, 'corner', {
        value: cornerValue,
        writable: true,
        configurable: true,
        enumerable: true
      });
    }

    callback();
  }

  readyObserver.observe(document.documentElement, { childList: true, subtree: true });

  try {
    Object.defineProperty(window, 'corner', {
      configurable: true,
      enumerable: true,
      get: function () { return cornerValue; },
      set: function (value) {
        cornerValue = value;
        finish();
      }
    });
    trapped = true;
  } catch (error) {}
}

// One shared observer drives every deferred setup task: each task returns true
// once it has done its job and is dropped, and the observer stops as soon as
// nothing is left waiting.
const pendingTasks = new Set();

const retryObserver = new MutationObserver(runPendingTasks);

function runPendingTasks() {
  pendingTasks.forEach(function (task) {
    if (task()) pendingTasks.delete(task);
  });

  if (pendingTasks.size === 0) retryObserver.disconnect();
}

function runWithRetry(task) {
  if (task()) {
    pendingTasks.delete(task);
    return;
  }

  if (pendingTasks.has(task)) return;

  pendingTasks.add(task);
  retryObserver.observe(document.body, { childList: true, subtree: true });
}

// The app renders the Packstation block once per page load, and Corner rebuilds
// the summary region whenever the cart goes empty and is filled again — which
// detaches the moved block for good. Keep the node and re-insert the same one.
let packstationBlock = null;

function movePackstationBlock() {
  const source = document.querySelector('#packstation-cart-selector');
  if (source && source !== packstationBlock) {
    packstationBlock = source;
    packstationContentObserver.disconnect();
    packstationContentObserver.observe(source, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  const block = packstationBlock;
  const target = document.querySelector('#corner-cowi-cart-summary-card');

  if (!block || !target) return false;
  if (block.isConnected && block.nextElementSibling === target) return true;

  target.parentNode.insertBefore(block, target);
  return true;
}

function setupPackstationPosition() {
  runWithRetry(movePackstationBlock);
}

function updateCartTitleCount(cartDetails) {
  var titleEl = document.querySelector('#cowi-corner-header-page-title span');
  if (!titleEl || !cartDetails || !Array.isArray(cartDetails.items)) return;

  if (!titleEl.dataset.baseText) {
    titleEl.dataset.baseText = titleEl.textContent.trim();
  }

  var count = cartDetails.items.reduce(function (sum, item) {
    return sum + (item.quantity || 0);
  }, 0);

  titleEl.textContent = count > 0
    ? titleEl.dataset.baseText + ' (' + count + ')'
    : titleEl.dataset.baseText;
}

function handleCartTitleCount(params) {
  updateCartTitleCount(params && params.cartDetails);
}

function updateProgressBarIcon() {
  var textEl = document.querySelector('#corner-cowi-cart-progress-bar-text');
  if (!textEl) return;

  var hasShipping = textEl.textContent.toLowerCase().indexOf(PROGRESS_ICON_SHIPPING_KEYWORD) !== -1;

  if (hasShipping) {
    textEl.style.setProperty('--progress-bar-icon', 'url("' + PROGRESS_ICON_DEFAULT + '")');
    textEl.removeAttribute('data-no-icon');
  } else {
    textEl.style.removeProperty('--progress-bar-icon');
    textEl.setAttribute('data-no-icon', '');
  }
}

var progressBarTextObserver = new MutationObserver(updateProgressBarIcon);

function bindProgressBarObserver() {
  var textEl = document.querySelector('#corner-cowi-cart-progress-bar-text');
  if (!textEl) return false;
  progressBarTextObserver.disconnect();
  progressBarTextObserver.observe(textEl, { childList: true, characterData: true, subtree: true });
  updateProgressBarIcon();
  return true;
}

function attachProgressBarObserver() {
  runWithRetry(bindProgressBarObserver);
}

function renderMilestoneClone(labelEl) {
  var source = labelEl.querySelector('span.px-1');
  if (!source) return;

  var clone = labelEl.querySelector('.milestone-label-clone');
  if (!clone) {
    clone = document.createElement('span');
    clone.className = 'milestone-label-clone';
    labelEl.appendChild(clone);
  }

  var text = source.textContent.trim();
  if (clone.dataset.sourceText === text) return;
  clone.dataset.sourceText = text;

  var match = text.match(MILESTONE_PRICE_RE);
  if (!match) {
    clone.textContent = text;
    return;
  }

  clone.textContent = match[1].trim();

  var priceEl = document.createElement('span');
  priceEl.className = 'milestone-price-part';
  priceEl.textContent = match[2].trim();
  clone.appendChild(priceEl);
}

function splitMilestoneLabelPrice() {
  var labels = document.querySelectorAll('[id^="corner-cowi-goal-milestone-label-"]');
  Array.prototype.forEach.call(labels, function (labelEl) {
    renderMilestoneClone(labelEl);
  });
}

var milestoneObserver = new MutationObserver(splitMilestoneLabelPrice);

function bindMilestoneObserver() {
  var wrapper = document.querySelector('.corner-cowi-progress-milestones-wrapper');
  if (!wrapper) return false;
  milestoneObserver.disconnect();
  milestoneObserver.observe(wrapper, { childList: true, characterData: true, subtree: true });
  splitMilestoneLabelPrice();
  return true;
}

function attachMilestoneObserver() {
  runWithRetry(bindMilestoneObserver);
}

function buildDiscountAccordion(discountSection) {
  var wrapper = document.createElement('details');
  wrapper.id = 'discount-accordion-wrapper';
  wrapper.className = 'packstation-cart-selector';

  var summary = document.createElement('summary');
  summary.innerHTML =
    '<div class="packstation-cart-header">' +
    '<div class="packstation-cart-header-title discount-header-title">' + DISCOUNT_ACCORDION_LABEL + '</div>' +
    '</div>' +
    '<svg class="packstation-cart-header-chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M4.16675 12.5L10.0001 6.66663L15.8334 12.5" stroke="#36383A" stroke-width="1.5" stroke-linecap="square"/></svg>';

  discountSection.parentNode.insertBefore(wrapper, discountSection);
  wrapper.appendChild(summary);
  wrapper.appendChild(discountSection);
}

function setupAccordions() {
  var packstation = document.querySelector('#packstation-cart-selector');
  if (packstation) {
    packstation.removeAttribute('open');
  }

  if (document.querySelector('#discount-accordion-wrapper')) return true;

  var discountSection = document.querySelector('#corner-cowi-cart-apply-discount-section');
  if (!discountSection) return false;

  buildDiscountAccordion(discountSection);
  return true;
}

function setupAccordionsWithRetry() {
  runWithRetry(setupAccordions);
}

function insertTrustpilotWidget() {
  if (document.querySelector('#cart-trustpilot-row')) return true;

  var discountWrapper = document.querySelector('#discount-accordion-wrapper');
  if (!discountWrapper) return false;

  var widgetDiv = document.createElement('div');
  widgetDiv.id = 'cart-trustpilot-row';
  widgetDiv.className = 'trustpilot-widget';
  widgetDiv.setAttribute('data-locale', TRUSTPILOT_LOCALE);
  widgetDiv.setAttribute('data-template-id', TRUSTPILOT_TEMPLATE_ID);
  widgetDiv.setAttribute('data-businessunit-id', TRUSTPILOT_BUSINESSUNIT_ID);
  widgetDiv.setAttribute('data-style-height', '20px');
  widgetDiv.setAttribute('data-style-width', '476px');
  widgetDiv.setAttribute('data-theme', 'light');

  discountWrapper.parentNode.insertBefore(widgetDiv, discountWrapper.nextSibling);

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(widgetDiv);
      }
    });
  });

  return true;
}

function setupTrustpilotRow() {
  runWithRetry(insertTrustpilotWidget);
}

const STICKY_FOOTER_ID = 'drawer-sticky-footer';

function moveCheckoutToStickyFooter() {
  const wrapper = document.querySelector('#corner-cowi-cart-wrapper');
  const card = document.querySelector('#corner-cowi-cart-summary-card');
  let footer = document.getElementById(STICKY_FOOTER_ID);

  if (!card) {
    if (footer) footer.remove();
    return true;
  }

  if (!wrapper) return false;

  const checkout = card.querySelector('corner-cart-checkout');

  if (!checkout) return !!(footer && footer.querySelector('corner-cart-checkout'));

  if (!footer) {
    footer = document.createElement('div');
    footer.id = STICKY_FOOTER_ID;
  }

  if (wrapper.lastElementChild !== footer) {
    wrapper.appendChild(footer);
  }

  footer.querySelectorAll('corner-cart-checkout').forEach(function (stale) {
    if (stale !== checkout) stale.remove();
  });

  footer.appendChild(checkout);
  return true;
}

function setupStickyFooter() {
  runWithRetry(moveCheckoutToStickyFooter);
}

const EU_GUARANTEE_SECTION = '/cart?section_id=drawer-eu-guarantee';
const EU_GUARANTEE_ROW_ID = 'drawer-eu-guarantee-row';

let euGuaranteeHtml = null;
let euGuaranteeFetched = false;
let euGuaranteeLoading = false;

function fillEuGuaranteeRow(row) {
  if (!euGuaranteeHtml || row.dataset.filled === '1') return;

  const tmp = document.createElement('div');
  tmp.innerHTML = euGuaranteeHtml;
  const inner = tmp.querySelector('.drawer-eu-guarantee-source-inner');
  if (!inner) return;

  row.innerHTML = '';
  row.appendChild(inner);
  row.dataset.filled = '1';
}

function placeEuGuaranteeRow() {
  if (!document.querySelector('#corner-cowi-cart-summary-card')) return true;

  if (euGuaranteeFetched && !euGuaranteeHtml) {
    const stale = document.getElementById(EU_GUARANTEE_ROW_ID);
    if (stale) stale.remove();
    return true;
  }

  const footer = document.getElementById(STICKY_FOOTER_ID);
  if (!footer) return false;

  let row = document.getElementById(EU_GUARANTEE_ROW_ID);
  if (!row) {
    row = document.createElement('div');
    row.id = EU_GUARANTEE_ROW_ID;
  }

  if (footer.firstElementChild !== row) {
    footer.insertBefore(row, footer.firstElementChild);
  }

  if (!euGuaranteeFetched) return false;

  fillEuGuaranteeRow(row);
  return true;
}

function setupEuGuarantee() {
  if (!euGuaranteeFetched && !euGuaranteeLoading) {
    euGuaranteeLoading = true;

    fetch(EU_GUARANTEE_SECTION)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const inner = tmp.querySelector('.drawer-eu-guarantee-source-inner');
        euGuaranteeHtml = inner ? inner.outerHTML : '';
        euGuaranteeFetched = true;
        runWithRetry(placeEuGuaranteeRow);
      })
      .catch(function () {})
      .then(function () { euGuaranteeLoading = false; });
  }

  runWithRetry(placeEuGuaranteeRow);
}

function updateCheckoutTotal() {
  var btn = document.querySelector('#corner-cowi-cart-summary-card-cta-button');
  var totalEl = document.querySelector('#corner-cowi-cart-cta-total-price-wrapper span:last-child');
  if (!btn || !totalEl) return;

  var total = totalEl.textContent.trim();
  if (total) {
    btn.setAttribute('data-checkout-total', total);
  }
}

var checkoutTotalObserver = new MutationObserver(updateCheckoutTotal);

function bindCheckoutTotalObserver() {
  var wrap = document.querySelector('#corner-cowi-cart-cta-total-price-wrapper');
  if (!wrap) return false;
  checkoutTotalObserver.disconnect();
  checkoutTotalObserver.observe(wrap, { childList: true, characterData: true, subtree: true });
  updateCheckoutTotal();
  return true;
}

function attachCheckoutTotalObserver() {
  runWithRetry(bindCheckoutTotalObserver);
}

function hasPackstationSelected() {
  try {
    return !!localStorage.getItem('packstationData');
  } catch (error) {
    return false;
  }
}

function initShopifyPaymentButtons() {
  try {
    if (window.Shopify && window.Shopify.PaymentButton &&
        typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
  } catch (error) {}
}

function updateExpressVisibility() {
  var row = document.querySelector('#drawer-express-checkout-row');
  if (!row) return;
  var host = row.querySelector('.express-checkout-buttons-host');
  var hasButtons = host && host.children.length > 0;
  row.style.display = (hasButtons && !hasPackstationSelected()) ? '' : 'none';
}

// Selecting or clearing a Packstation only writes localStorage and fires no
// Corner cart event, but the app always re-renders its own block — that render
// is the signal to re-check whether the express buttons may be shown.
const packstationContentObserver = new MutationObserver(function () {
  updateExpressVisibility();
});

function ensureExpressRow() {
  var ctaWrapper = document.querySelector('#corner-cowi-cart-cta-wrapper');
  if (!ctaWrapper) return null;

  var row = document.querySelector('#drawer-express-checkout-row');
  if (row) return row;

  row = document.createElement('div');
  row.id = 'drawer-express-checkout-row';
  row.style.display = 'none';

  var divider = document.createElement('div');
  divider.className = 'express-checkout-divider';
  var label = document.createElement('span');
  label.textContent = EXPRESS_CHECKOUT_LABEL;
  divider.appendChild(label);

  var host = document.createElement('div');
  host.className = 'express-checkout-buttons-host';

  row.appendChild(divider);
  row.appendChild(host);
  ctaWrapper.parentNode.insertBefore(row, ctaWrapper.nextSibling);
  return row;
}

var expressCheckoutFetched = false;
var expressCheckoutLoading = false;

function setupExpressCheckout() {
  var row = ensureExpressRow();
  if (!row) return;

  const host = row.querySelector('.express-checkout-buttons-host');
  const hasButtons = host && host.children.length > 0;

  if ((expressCheckoutFetched && hasButtons) || expressCheckoutLoading) {
    updateExpressVisibility();
    return;
  }
  expressCheckoutLoading = true;

  fetch('/cart?section_id=express-checkout')
    .then(function (response) { return response.text(); })
    .then(function (html) {
      var host = row.querySelector('.express-checkout-buttons-host');
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('.drawer-express-source-inner');
      if (host && inner) {
        host.innerHTML = '';
        host.appendChild(inner);
        expressCheckoutFetched = true;
        updateExpressVisibility();
        requestAnimationFrame(function () {
          requestAnimationFrame(initShopifyPaymentButtons);
        });
      }
    })
    .catch(function () {})
    .then(function () {
      expressCheckoutLoading = false;
      updateExpressVisibility();
    });
}

// Corner does not always emit a cart event when it rebuilds the drawer (adding
// an item from a collection grid while the drawer is open is one case), so the
// customisations are re-applied whenever a fresh summary card shows up.
let lastSummaryCard = null;

const drawerRerenderObserver = new MutationObserver(function () {
  const card = document.querySelector('#corner-cowi-cart-summary-card');
  if (card === lastSummaryCard) return;
  lastSummaryCard = card;
  refreshCartDrawer();
});

function watchDrawerRerenders() {
  drawerRerenderObserver.disconnect();
  drawerRerenderObserver.observe(document.body, { childList: true, subtree: true });
}

function refreshCartDrawer(params) {
  lastSummaryCard = document.querySelector('#corner-cowi-cart-summary-card');
  setupStickyFooter();
  setupPackstationPosition();
  setupAccordionsWithRetry();
  setupTrustpilotRow();
  attachProgressBarObserver();
  attachMilestoneObserver();
  attachCheckoutTotalObserver();
  setupExpressCheckout();
  setupEuGuarantee();
  handleCartTitleCount(params);
}

function initCornerCartCustom() {
  corner.on('cornerCartReady', refreshCartDrawer);
  corner.on('onCowiOpen', refreshCartDrawer);
  corner.on('onCartEdit', refreshCartDrawer);
  refreshCartDrawer();
  watchDrawerRerenders();
}

whenCornerReady(initCornerCartCustom);

(function () {
  'use strict';

  var CORNER_CHECKOUT_SELECTOR =
    'corner-cart-checkout, #corner-cowi-cart-summary-card-cta-button';

  function buildCheckoutUrl(cartItems, packstationData) {
    var customerNumber = packstationData.customerNumber;
    var postalCode = packstationData.postalCode;
    var city = packstationData.city || 'Frankfurt';
    var countryCode = packstationData.countryCode || 'DE';
    var name = packstationData.name || 'Packstation';

    var url = '/cart/';
    if (cartItems && cartItems.length > 0) {
      url += cartItems
        .map(function (item) { return item.id + ':' + item.quantity; })
        .join(',');
    }
    url += '?';

    var params = {
      'checkout[shipping_address][address1]': name,
      'checkout[shipping_address][address2]': customerNumber,
      'checkout[shipping_address][city]': city,
      'checkout[shipping_address][zip]': postalCode,
      'checkout[shipping_address][country]': countryCode
    };

    if (countryCode === 'DE') {
      params['checkout[shipping_address][province]'] = 'HE';
    }

    var discountCode = new URLSearchParams(window.location.search).get('discount');
    if (discountCode) {
      params['discount'] = discountCode;
    }

    var queryString = Object.keys(params)
      .map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      })
      .join('&');

    return url + queryString;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest(CORNER_CHECKOUT_SELECTOR);
    if (!trigger) return;

    var packstationDataJson = localStorage.getItem('packstationData');
    if (!packstationDataJson) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var packstationData;
    try {
      packstationData = JSON.parse(packstationDataJson);
    } catch (error) {
      window.location.href = '/checkout';
      return;
    }

    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Cart API error: ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        window.location.href = buildCheckoutUrl(cart.items, packstationData);
      })
      .catch(function (error) {
        console.error('Error processing Packstation data for Corner checkout:', error);
        window.location.href = '/checkout';
      });
  }, true);
})();
